import React, { FC, useContext, useEffect } from 'react'

import RedirectTo from 'Components/RedirectTo'
import { ApplicationContext } from 'Context'
import { Routes, Route } from 'react-router-dom'
import AreasGeograficas from 'Views/Cadastros/AreasGeograficas'
import Empresas from 'Views/Cadastros/Empresas'
import Motoristas from 'Views/Cadastros/Motoristas'
import Rastreadores from 'Views/Cadastros/Rastreadores'

const InnerContent: FC = () => {
  const { applicationContext } = useContext(ApplicationContext)

  useEffect(() => {
    if (!applicationContext.usuarioAtual) {
      location.assign('/session-close')
    }
  }, [])

  return (
    <Routes>
      <Route path="/" element={<RedirectTo to="/Docas" />} />
      <Route path="/inicial" element={<RedirectTo to="/Docas" />} />
      {/* <Route path="/inicial" element={<PainelAuditor />} /> */}
      <Route path="/Entidade/*" element={<Empresas />} />
      <Route path="/Motorista/*" element={<Motoristas />} />
      <Route path="/Rastreador/*" element={<Rastreadores />} />
      <Route path="/AreaGeografica/*" element={<AreasGeograficas />} />
    </Routes>
  )
}

export default InnerContent
